/**
 * Asychronously flushes matching storage keys if they've expired
 * @param {String|RegExp} matches A string or RegExp to match keys
 * @param {WebStorage} [storage]
 */
export const flushExpiredItemsMatching = async (matches, storage) => {
    const keys = await storage.getAllKeys();
    const filtered = keys
        ? keys.filter((key) => {
            if (typeof matches === 'string') {
                return key.toString().includes(matches);
            }
            return matches.test(key.toString());
        })
        : [];
    const promiseMap = filtered.map(async (key) => {
        const stringKey = key.toString();
        const isExpired = await storage.isExpired(stringKey);
        if (isExpired) {
            return storage.remove(key.toString());
        }
    });
    await Promise.all(promiseMap);
};
/**
 * Asychronously flushes matching storage keys
 * @param {String|RegExp} matches A string or RegExp to match keys
 * @param {WebStorage} [storage]
 */
export const flushItemsMatching = async (matches, storage) => {
    const keys = await storage.getAllKeys();
    const filtered = keys
        ? keys.filter((key) => {
            if (typeof matches === 'string') {
                return key.toString().includes(matches);
            }
            return matches.test(key.toString());
        })
        : [];
    const promiseMap = filtered.map((key) => storage.remove(key.toString()));
    await Promise.all(promiseMap);
};
/**
 * Standardizes `options` to an object and returns that object
 * TODO: Remove when `expiry` as a number is deprecated
 */
export const getStandardizedOptions = (expiryOrOptions) => ({
    expiry: typeof expiryOrOptions === 'number' ? expiryOrOptions : expiryOrOptions.expiry,
    persist: typeof expiryOrOptions === 'number' ? false : expiryOrOptions.persist,
});
